<template>
    <HpoPatientModalSection :title="pgettext('label', 'Transport Priority')">
        <template v-slot:summary>
            {{ PriorityLabel[modelValue] }}
        </template>

        <template v-slot:body>
            <div class="phc-buttons-row priority-buttons">
                <SelectButton :value="Priority.I_IIA"
                              v-model="priority"
                              :cssClasses="phcButtonClass('red', Priority.I_IIA)">
                    {{ PriorityLabel[Priority.I_IIA] }}
                </SelectButton>

                <SelectButton :value="Priority.I_IIB"
                              v-model="priority"
                              :cssClasses="phcButtonClass('red', Priority.I_IIB)">
                    {{ PriorityLabel[Priority.I_IIB] }}
                </SelectButton>

                <SelectButton :value="Priority.IIA"
                              v-model="priority"
                              :cssClasses="phcButtonClass('red', Priority.IIA)">
                    {{ PriorityLabel[Priority.IIA] }}
                </SelectButton>

                <SelectButton :value="Priority.IIB"
                              v-model="priority"
                              :cssClasses="phcButtonClass('yellow', Priority.IIB)">
                    {{ PriorityLabel[Priority.IIB] }}
                </SelectButton>

                <SelectButton :value="Priority.III"
                              v-model="priority"
                              :cssClasses="phcButtonClass('green', Priority.III)">
                    {{ PriorityLabel[Priority.III] }}
                </SelectButton>

                <SelectButton :value="Priority.IV"
                              v-model="priority"
                              :cssClasses="phcButtonClass('black', Priority.IV)">
                    {{ PriorityLabel[Priority.IV] }}
                </SelectButton>
            </div>
        </template>
    </HpoPatientModalSection>
</template>

<script>
import HpoPatientModalSection from "../../HpoPatientModalSection.vue";
import {phcButtonClass} from "../../utils";
import {Priority, PriorityLabel} from "@/components/hpo/choices"
import {WORKPLACE_TYPE} from "../../../choices";
import SelectButton from "../../SelectButton.vue"
import {computed, ref, watch} from "vue"


export default {
    name: 'HpoPatientModalPhcSection',
    components: {HpoPatientModalSection, SelectButton},
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String,
            required: false,
            default: null,
        },
    },
    setup(props, ctx) {
        const priority = computed({
            get: () => props.modelValue,
            set: (value) => ctx.emit('update:modelValue', value)
        });

        return {
            priority,
            // Imports
            phcButtonClass,
            Priority,
            PriorityLabel,
            WORKPLACE_TYPE,
        }
    },
}
</script>

